<template>
    <v-select
        :model-value="spaClientStore.clientType"
        :items="spaClientOptions"
        item-title="label"
        item-value="value"
        label="Spa client"
        prepend-inner-icon="mdi-swap-horizontal"
        title="Spa client"
        density="compact"
        variant="outlined"
        hide-details
        class="spa-client-selector"
        @update:model-value="onChange"
    />
</template>

<script lang="ts" setup>
import { useSpaClientStore, type SpaClientType } from '@/stores/spaClient'

const spaClientStore = useSpaClientStore()

const spaClientOptions = [
    { label: 'IoT (default)', value: 'iot' as SpaClientType },
    { label: 'Vessel (legacy)', value: 'vessel' as SpaClientType }
]

const onChange = (type: SpaClientType) => {
    if (type === spaClientStore.clientType) return
    spaClientStore.setClientType(type)
}
</script>

<style lang="scss" scoped>
.spa-client-selector {
    max-width: 200px;
}
</style>
